import cn from 'classnames';
import React from 'react';

import {Button, ButtonDark} from '../../../components/Button';
import Popup from '../../../components/Popup/Popup';
import appConfig from '../../../config/appConfig';
import * as localizationKeys from '../../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import loyaltyClubService from '../../../services/market/loyaltyClubService';
import modalService from '../../../services/modalService';
import styles from './LoyaltyClubPopup.module.scss';

const LoyaltyClubPopup = ({modalType}) => {
    const loyaltyClubDashboardUrl = appConfig.getLoyaltyClubDashboardUrlFormatted();
    const localizedStrings = getLocalizedStrings();

    const onRedirectToSsoLink = async () => await loyaltyClubService.redirectToLoyaltyClubSsoLinkDashboard();

    const onClose = () => modalService.hideModal(modalType);

    const title = localizedStrings[localizationKeys.LOYALTY_CLUB_CONGRATS_POPUP_TITLE];

    return (
        <Popup
            className={styles.Popup}
            contentLabel={title}
            onClose={onClose}
            closeButtonAriaLabel={localizedStrings[localizationKeys.LOYALTY_CLUB_CONGRATS_POPUP_BTN_CANCEL_ARIA_LABEL]}
        >
            <h2 className={styles.Title}>{title}</h2>
            <p className={cn(styles.Description, 'ica--txt-regular')}>
                {localizedStrings[localizationKeys.LOYALTY_CLUB_CONGRATS_POPUP_DESCRIPTION]}
            </p>
            {loyaltyClubDashboardUrl && (
                <ButtonDark onClick={onRedirectToSsoLink} className={styles.ButtonPrimary} showArrow>
                    {localizedStrings[localizationKeys.LOYALTY_CLUB_CONGRATS_POPUP_CHECK_BUTTON_TEXT]}
                </ButtonDark>
            )}
            <Button className={styles.ButtonSecondary} onClick={onClose}>
                {localizedStrings[localizationKeys.LOYALTY_CLUB_CONGRATS_POPUP_SKIP_BUTTON_TEXT]}
            </Button>
        </Popup>
    );
};

export default LoyaltyClubPopup;
